// API names for external API configurations
export const API_NAMES = {
    DATASHARING: 'datasharing',
    ACTIVITY_SERVICE: 'activity-service',
    PLANNING: 'planning',
    USER_CONFIG: 'user-config',
    ATHLETE_SERVICE: 'athlete-service',
} as const;

export type ApiName = (typeof API_NAMES)[keyof typeof API_NAMES];
